import {payrollInheritedNode} from '../payroll-utils'
import {BreakdownNode} from './breakdown-node'
import {breakdownDetails, formatBreakdown} from './breakdown-utils'
export function AddendCategoryNode(a, e){
  var p = payrollInheritedNode({
    key: 'addendCategory',
    childsKey: 'breakdown',
    childConstructor: BreakdownNode
  },a, e)
  p.getBreakdown = v=>p.breakdown.find(b=>b.details.id==v)
  p.getBreakdownP = v=>p.breakdown.find(b=>b.details.id==b.details.id)
  p.breakdownFields = typeof(breakdownDetails[p.details.id])==='undefined'?
    []:breakdownDetails[p.details.id].concat([])
  p.formattedBreakdown = p.breakdown.map(b=>formatBreakdown(b))
  return p
}
